import React, { useState } from "react";
import { Alert } from "@material-ui/lab";
import { useTranslation } from "react-i18next";
import PageSpinner from "../../../../elements/spinner/PageSpinner";
import DialogModal from "../../../../elements/dialogModal/DialogModal";
import TwoFa from "../../../../elements/twoFa/TwoFa";
import { check2FA } from "../../../../../utils/check2FA";
import getUserInfo from "../../../../../utils/getUserInfo";
import axios from "axios";
import { HTTP_STATUSES } from "../../../../../utils/consts";
import userAuthenticationConfig from "../../../../../utils/userAuthenticationConfig";

import MaterialSwitch from "../../../../styles/materialSwitch";
import {
  StyledCol,
  StyledScrollTable,
  StyledTable,
  StyledTableBody,
  StyledTableHead,
  StyledTableRow
} from "../../../../styles/styledTable";
import { StyledBreakWord } from "../../../../styles/styledBreakWord";

const ProjectList = ({ userProjects, userId, notification, setNotification, refetch, setRefetch }) => {
  const { t } = useTranslation("supportUserPage");

  const [error, setError] = useState({});
  const [open, setOpen] = useState(false);
  const [changeProject, setChangeProject] = useState({
    id: null,
    user: userId,
    project: null
  });

  const handleChange = async (event) => {
    event.preventDefault();

    let check2Fa = await check2FA(getUserInfo()["userId"], event.target.twofa.value);

    if (check2Fa.error) {
      setNotification({ ...notification, visible: true, type: "error", message: check2Fa.error });
      return;
    }

    if (!changeProject.id) {
      let data = {
        user: changeProject.user,
        project: changeProject.project
      };

      createUserService(data);
    } else {
      deleteUserService(changeProject.id);
    }
  };

  const createUserService = (data) => {
    axios.post("/api/user-support-projects", data, userAuthenticationConfig(false)).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_CREATED) {
        setNotification({
          ...notification,
          visible: true,
          type: "success",
          message: t("list.success")
        });
        setRefetch(!refetch);
      }
    }).catch(error => {
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    }).finally(() => setOpen(false));
  };

  const deleteUserService = (changeProjectId) => {
    axios.delete("/api/user-support-projects/" + changeProjectId, userAuthenticationConfig()).then(response => {
      setNotification({
        ...notification,
        visible: true,
        type: "success",
        message: t("details.projects.table.success")
      });
      setRefetch(!refetch);
    }).catch(error => {
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    }).finally(() => setOpen(false));
  };

  if (!userProjects) {
    return <PageSpinner position="center" pt="20" pb="20" />;
  }

  if (userProjects.length === 0) {
    return <Alert severity="warning">{t("details.projects.table.emptyData")}</Alert>;
  }

  return (
    <>
      <DialogModal
        open={open}
        setOpen={setOpen}
        title={t("details.projects.enableAccess")}
        content={<TwoFa
          handleSubmit={handleChange}
          error={error}
        />}
      />
      <StyledScrollTable>
        <StyledTable
          width="768"
          size="14"
          className="projects-table"
        >
          <StyledTableHead
            scroll="auto"
            col="4"
            className="projects-table__head"
          >
            <div>
              {t("details.projects.table.access")}
            </div>
            <div>
              {t("details.projects.table.name")}
            </div>
            <div className="projects-table__create-date">
              {t("details.projects.table.userName")}
            </div>
            <div>
              E-mail
            </div>
          </StyledTableHead>
          <StyledTableBody>
            {userProjects && userProjects.map((value, key) => (
              <StyledTableRow
                key={key}
                scroll="auto"
                col="4"
                className="projects-table__row"
              >
                <StyledCol className="projects-table__project-name">
                  <MaterialSwitch
                    checked={!!value.userSupportProjectId}
                    name={value.name}
                    onChange={() => {
                      setChangeProject({ ...changeProject, id: value.userSupportProjectId, project: value.id });
                      setOpen(true);
                    }}
                  />
                </StyledCol>
                <StyledCol className="projects-table__project-name">
                  {value.name}
                </StyledCol>
                <StyledCol className="projects-table__project-name">
                  {value.user.firstname} {value.user.lastname}
                </StyledCol>
                <StyledCol className="projects-table__project-name" inline>
                  <StyledBreakWord>
                    {value.user.email}
                  </StyledBreakWord>
                </StyledCol>
              </StyledTableRow>
            ))}
          </StyledTableBody>
        </StyledTable>
      </StyledScrollTable>
    </>
  );
};
export default ProjectList;